import { transferOrderIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const deleteTransfer = {
  name: "deleteTransfer" as const,
  input: z.object({ transferId: transferOrderIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
